import { personFields } from './biography'

export const analysisFields = `
title
titleEn
text
textFr
textEn
date
type
slug
authors{
firstName
lastName
}
toc {
  title
  anchor
  children {
    title
    anchor
    children {
      title
      anchor
    }
  }
}
image {
  getUrl
}
composer {
  ${personFields}
}
cardImage {
  url
  isIcon
  alt
  centered
}
cardTitle
cardTitleEn
cardDescription
cardDescriptionEn
cardPersons{
  firstName
  lastName
}
`

export const analyses = () => {
  return `query analyses {
    analyses {
    ${analysisFields}
    }
  }`
}
export const getAnalysisBySlug = () => {
  return `query analysisBySlug($slug: String!) {
  analysisBySlug(slug: $slug) {
    ${analysisFields}
  }
  }`
}

export const getAnalysisByComposerSlug = () => {
  return `query analysesByComposerSlug($slug: String!) {
    personBySlug(slug: $slug) {
      ${personFields}
          }
  analysesByComposerSlug(slug: $slug) {
    title
    text
    date
    type
    slug
    image {
      getUrl
    }
    composer {
      ${personFields}
    }
  }
  }`
}

export const getDefinitionBySlug = () => {
  return `query definitionBySlug($slug: String!) {
  definitionBySlug(slug: $slug) {
    name
    text
  }
  }`
}
